import './css/dashboardtable.css';
import './css/editform.css';
import React, { useState, useEffect } from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';
import { useLocation, useParams } from 'react-router-dom';




function EditAbout() {



    useEffect(() => {
        axios.get('session')
            .then((res) => {
                if (res.data.valid) {
                    if (res.data.type !== "admin") {
                        navigate('/admin-login');
                    }
                } else {
                    // Handle the case when session is not valid
                }
            })
            .catch((err) => console.log(err));
    }, []);




    const [formChanged, setFormChanged] = useState(false); // Track if the form has changed


    const handleInputChange = () => {
        setFormChanged(true); // Set the formChanged flag to true when any input changes
    };




    const navigate = useNavigate();
    const [AboutData, setAboutData] = useState({});
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');


    const [formInputs, setFormInputs] = useState({
        header: "",
        para_1: "",
        para_2: "",
        video: null, // New state for video

    });
    
    // Use formInputs to set the initial value of inputs
    useEffect(() => {
        if (AboutData.id) {
        setFormInputs({
            header: AboutData.header,
            para_1: AboutData.para_1,
            para_2: AboutData.para_2,
        });
        }
    }, [AboutData]);

    const handleChange = (e) => {
        setFormChanged(true);
        const { name, value, type } = e.target;
        const inputValue = type === "file" ? e.target.files[0] : value;

        setFormInputs(prevFormInputs => ({
            ...prevFormInputs,
            [name]: inputValue,
        }));
    };
        
        const handleSubmit = async (e) => {
            e.preventDefault();
        
            let Loading = document.querySelector(".loading-screen");
            Loading.classList.add("active");
        
            const { header, para_1, para_2, video } = formInputs;
        
            if (!header || !para_1 || !para_2) {
                return alert("All fields are required");
            }
        
            try {
            const form = new FormData();
            form.append("id", id);
            form.append("header", header);
            form.append("para_1", para_1);
            form.append("para_2", para_2);
            form.append("video", video);

            const response = await axios.post("/update-about-us", form);
        
            if (response.status === 200) {
                // Update LandingSlide state after a successful update
                setAboutData((prevAboutData) => ({
                ...prevAboutData,
                header, para_1,para_2,
                }));
        
                Loading.classList.remove("active");
                let alertS = document.querySelector(".alert-success");
                alertS.classList.add("active");
        
                setTimeout(() => {
                alertS.classList.remove("active");
                }, 3000);
            } else {
                Loading.classList.remove("active");
                let alertD = document.querySelector(".alert-danger");
                alertD.classList.add("active");
                setTimeout(() => {
                alertD.classList.remove("active");
                }, 3000);
            }
            } catch (error) {
            console.error(error);
            alert("Server error");
            }
        };




    axios.defaults.withCredentials = true;
    
    const getAboutData = (itemId) => {
        let table = "about_us";
        axios.post('get-item', { itemId, table })
            .then((res) => {
                if (res.data.message) {
                } else {
                    setAboutData(res.data);
                }
            })
            .catch((err) => console.log(err));
    };




    const getIfLogin = () => {
        axios.get('session')
            .then((res) => {
                if (!res.data.valid || id <= 0 || id == null || id == "") {
                    navigate('/admin-login');
                } else {
                    getAboutData(id);
                }
            })
            .catch((err) => console.log(err));
    };
    



    useEffect(() => {
        getIfLogin();
        getAboutData(id);
    }, []);
    
    return (
        <>

<div className='loading-screen'>
                            <div class="loader">
                                <div class="outer"></div>
                                <div class="middle"></div>
                                <div class="inner"></div>
                            </div>

                        </div>
            <section className='dashboard'>
                <div className='edit-form'>

                
                <div className='alert-success'>
                        <h1> Data Added successfully  <i class="las la-check-circle"></i></h1>
                    </div>

                    <div className='alert-danger'>
                        <h1> Failed To Add Data <i class="las la-exclamation-triangle"></i></h1>

                    </div>


                    <form onSubmit={handleSubmit}>

                        <div className='input'>
                            <label> Header  </label>
                            <input value={formInputs.header} onChange={handleChange} type='text' required="required"  maxLength="200" name='header'/>
                        </div>


                        <div className='input'>
                            <label> Text  One </label>
                            <textarea value={formInputs.para_1} onChange={handleChange} type='text' required="required"  maxLength="700" name='para_1'>
                                
                            </textarea>
                        </div>


                        
                        <div className='input'>
                            <label> Text  Two </label>
                            <textarea value={formInputs.para_2} onChange={handleChange} type='text' required="required"  maxLength="700" name='para_2'>
                                
                            </textarea>
                        </div>

                        <div className='input'>
                            <label> Video File </label>
                            <input onChange={handleChange} type='file' accept="video/*" name='video'/>
                        </div>

                                <button disabled={!formChanged} type='submit'> Update </button>
                            </form>
                        </div>
                    </section>
                </>
            );
            }
            


            export default EditAbout;
